import { observer } from 'mobx-react';
import { FC, useCallback } from 'react';
import { customerWalletModalStore } from '../../store';
import { localeStore } from 'src/mobx/localesStore';
import { TOOLTIP_DURATION, TOOLTIP_POSITION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import Input from 'src/view/components/Controls/InputComponent/Input';
import Text from 'src/view/components/Text/Text';

const CustomerWalletModalCorrectBlock: FC = observer((): JSX.Element | null => {
  const { loading, isTopUpMode, correction, currentWalletNumbers, validation } = customerWalletModalStore;

  const updateAmount = useCallback((value: string | undefined) => {
    customerWalletModalStore.updateAmount(value);
  }, []);

  const updateReason = useCallback((value: string | undefined) => {
    customerWalletModalStore.updateReason(value);
  }, []);

  if (isTopUpMode) return null;

  return (
    <div className="d-flex flex-column gap-25">
      <div className="d-flex flex-column gap-10">
        <Text
          type="block-header"
          text="correction_amount"
          required
          tooltip={{ message: 'wallet_correction_amount_tooltip', duration: TOOLTIP_DURATION.EXTRA_LARGE, position: TOOLTIP_POSITION.PORTAL }}
        />
        <Input
          type="floatNumber"
          value={correction.amount}
          onChangeValue={updateAmount}
          disabled={loading || !currentWalletNumbers}
          validation={validation.amount}
          placeholder={localeStore.t('Value')}
          contentClassName="full-width"
        />
      </div>

      <div className="d-flex flex-column gap-10">
        <Text type="block-header" text="correction_reason" required />
        <Input
          type="text"
          value={correction.reason}
          onChangeValue={updateReason}
          disabled={loading || !currentWalletNumbers}
          validation={validation.reason}
          placeholder={localeStore.t('Value')}
          contentClassName="full-width"
        />
      </div>
    </div>
  );
});

export default CustomerWalletModalCorrectBlock;
